import React, { Component } from "react";
import { Link } from "react-router-dom";
import HtmlToReactParser from "html-to-react";
import "./index.css";
import CalendarPicker from "rc-calendar";
import Dropdown from "../Dropdown";
import RightMenu from "../RightMenu";
import CustomCarousel from "../CustomCarousel"
import RightIconMenu from "../RightIconMenu";

export default class View_type_10 extends Component {
	constructor(props) {
		super(props);
		var data = { list: [], ...props.data };
		this.state = {
			data: data,
			prevDropdown: data.prev_dropdown,
			rightIconMenu: data.right_icon_menu ? data.right_icon_menu : [],

		};
		//console.log("View_type_10: ", this.state);
	}

	render() {
		var object = this.state.data;
		return (
			<div className={`${this.state.prevDropdown && this.state.prevDropdown.dates && this.state.prevDropdown.dates.length > 5 ? 'vt10 vt10--flex-nav' : 'vt10'}`}>
				<div className="vt10 col-xs-12 col-sm-12 col-md-12 col-lg-9">
					<div className="vt10 row">
						{this.state.prevDropdown && this.state.prevDropdown.dates ? (
							<div className="custom-carousel-wrapper">
								<CustomCarousel data={this.state.prevDropdown} />
							</div>
						) : null}

						<div className="vt10 artists-pageTitle">{object.header}</div>

						<div className="vt10 flex-container">
							{object.list.map(function (news, index) {
								var category = news.category;
								var title = news.title;
								var description = news.description;
								var color = news.color;
								var image = news.image;
								var url = news.url;
								return (
									<div
										className="vt10 wrapped-item col-xs-12 col-sm-4 col-md-4 col-lg-4"
										key={index}
									>
										<Link className="vt10 more_button" to={url}>
											<div className="vt10 middle-postblock">
												<div className="vt10 middle-thumbnailholder">
													<img src={image} alt="" />
													<div className="vt10 middlepost-thumbnail" />
												</div>
												<p
													className="vt10 middlepost-titleitem"
													dangerouslySetInnerHTML={{ __html: title }}
												/>
												<p
													className="vt10 middlepost-description"
													dangerouslySetInnerHTML={{ __html: description }}
												/>
												<div className="vt10 middle-addelem" />
											</div>
										</Link>
									</div>
								);
							})}
						</div>

					</div>
				</div>
				<div className={`${this.state.prevDropdown && this.state.prevDropdown.dates && this.state.prevDropdown.dates.length > 5 ? 'vt2 right col-xs-3 col-sm-3 col-md-3 col-lg-3 dropdown--nav-flex' : 'vt2 right col-xs-3 col-sm-3 col-md-3 col-lg-3'}`}>
					{this.state.data.right_menu && (
						<div className="vt2 RightMenu">
							{/* <Dropdown giveMeClassName={`${this.state.prevDropdown && this.state.prevDropdown.dates && this.state.prevDropdown.dates.length > 5 ? 'festiwal--dropdown' : 'normal'}`} data={this.state.prevDropdown} /> */}
							<RightMenu data={this.state.data.right_menu} />
						</div>
					)}
					{this.state.rightIconMenu &&
						<RightIconMenu data={this.state.rightIconMenu} />
					}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Components/Elements/View_type_10/index.js